module.exports = __webpack_public_path__ + "static/media/uoit.1a288c75.JPG";